import Helmet from 'react-helmet';
import React from 'react';
import { string, arrayOf, object } from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';

const SEO = ({
  description, meta, lang, pageTitle,
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            author
            description
            keyWords
            seoTitle
            sharingImage
            siteUrl
            title
          }
        }
      }
    `,
  );

  const metaDescription = description || site.siteMetadata.description;
  const {
    sharingImage, siteUrl, seoTitle, title,
  } = site.siteMetadata;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={seoTitle || pageTitle}
      titleTemplate={`%s | ${title}`}
      meta={[
        {
          name: 'author',
          content: site.siteMetadata.author,
        },
        {
          name: 'keywords',
          content: site.siteMetadata.keyWords,
        },
        {
          name: 'description',
          content: metaDescription,
        },
        {
          name: 'og:url',
          content: siteUrl,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: metaDescription,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:image',
          content: `${siteUrl}/${sharingImage}`,
        },
        {
          name: 'theme-color',
          content: '#38C9F2',
        },
      ].concat(meta)}
    />
  );
};

SEO.propTypes = {
  description: string,
  lang: string,
  meta: arrayOf(object),
  pageTitle: string,
};

SEO.defaultProps = {
  description: '',
  lang: 'ru',
  meta: [],
  pageTitle: null,
};

export default SEO;
